import { useContext } from "react";
import TrainTrackContext from "./TrainTrackContext";

export default function useTrainTracks() {
    return useContext(TrainTrackContext);
}
